export default "__VITE_ASSET__CPmDVt7B__"